import { Enums, Interfaces } from '@configur-tech/upit-core-types';
import React, { FC, useEffect, useState } from 'react';
import {
  StyledBodySubHeader,
  StyledDropdownUltraWide,
  StyledText,
} from '../../../../main/theme';

import { DropdownItemProps } from 'semantic-ui-react';

interface TextEmptyCheckProps {
  field: Interfaces.Field;
  setDataValidation: (dataValidation: Interfaces.DataValidation) => void;
  setSuperColumnValid: (valid: boolean) => void;
  loaded: boolean;
  columnNameOptions: DropdownItemProps[];
}

const TextEmptyCheck: FC<TextEmptyCheckProps> = ({
  field,
  setDataValidation,
  setSuperColumnValid,
  loaded,
  columnNameOptions,
}) => {
  const [selectedColumnName, setSelectedColumnName] = useState<string>();

  // Set values if updating existing
  useEffect(() => {
    if (field) {
      const opts = field.dataValidation
        ?.textTransformation as Interfaces.SingleFieldOp;

      if (opts) {
        setSelectedColumnName(opts.params.field);
      }
    }
  }, [field]);

  // Set selected
  useEffect(() => {
    if (selectedColumnName) {
      setSuperColumnValid(true);
      setDataValidation({
        dataValidationType: Enums.ValueDataType.TEXT_TRANSFORMATION,
        textTransformation: {
          type: Enums.TextTransformOperation.EMPTY_CHECK,
          params: {
            field: selectedColumnName,
          },
        },
      });
    } else {
      setSuperColumnValid(false);
    }
  }, [selectedColumnName, setDataValidation, setSuperColumnValid]);

  return (
    <>
      <StyledBodySubHeader>Empty Value Check</StyledBodySubHeader>

      <StyledText>
        This super column will return true if the value is empty and false if it
        is not.
      </StyledText>

      <StyledText>
        Select which column you would like to check for empty values.
      </StyledText>

      <StyledDropdownUltraWide
        selectOnBlur={false}
        loading={!loaded}
        placeholder={'Select column'}
        options={columnNameOptions}
        selection
        search
        value={selectedColumnName}
        onChange={(e, data) => setSelectedColumnName(data.value)}
        style={{ marginTop: 0 }}
      />
    </>
  );
};

export default TextEmptyCheck;
